import React from "react";
import { motion } from "framer-motion";
import { PHOTOS, fadeUp } from "../../data";

export const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32" style={{ background: "#FFFFFF" }}>
      <div className="container-x">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }}
          className="flex items-center gap-3 mb-6">
          <span className="h-px w-10" style={{ background: "var(--blue)" }} />
          <span className="eyebrow" style={{ color: "var(--blue)" }}>About Puttraj</span>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* image */}
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="lg:col-span-5 relative spotlight">
            <div className="overflow-hidden rounded-[18px] shadow-[0_20px_40px_rgba(0,0,0,0.12)]">
              <img src={PHOTOS.chair} alt="Editorial portrait of Puttraj, public leader from Bengaluru, Karnataka"
                className="w-full h-[440px] md:h-[560px] object-cover hover:scale-105 transition-transform duration-[1.2s]" />
            </div>
          </motion.div>

          {/* copy */}
          <div className="lg:col-span-7">
            <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight"
              style={{ color: "var(--navy)" }}>
              A journey built around people
            </motion.h2>

            <div className="mt-7 space-y-6 font-body text-base md:text-lg leading-relaxed" style={{ color: "var(--text2)" }}>
              {[
                "Puttraj is an entrepreneur and public figure from Bengaluru — someone who has spent his career building things, telling stories and, most of all, working with people.",
                "With an MBA in Marketing, his path has wound through real estate, media and film. Each chapter taught him something different, but they all came back to the same idea: understand people, and you can build almost anything.",
                "These days, his energy is pointed at the community — listening to what people are going through, and lending a hand where it counts.",
              ].map((p, i) => (
                <motion.p key={i} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }}>
                  {p}
                </motion.p>
              ))}
            </div>

            <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="flex flex-wrap gap-3 mt-9">
              {["Entrepreneur", "Media Leader", "Film Producer", "Real Estate"].map((t) => (
                <span key={t} className="font-body text-sm font-medium px-4 py-2 rounded-full border"
                  style={{ borderColor: "var(--grey)", color: "var(--navy)", background: "#fff" }}>
                  {t}
                </span>
              ))}
            </motion.div>

            <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
              data-testid="affiliation-badge"
              className="inline-flex items-center gap-2.5 mt-6 px-4 py-2.5 rounded-full border"
              style={{ borderColor: "var(--grey)", background: "var(--softblue)" }}>
              <img src="/photos/congress.png" alt="Indian National Congress" className="h-6 w-6 rounded-full object-contain" />
              <span className="font-body text-sm font-medium" style={{ color: "var(--charcoal)" }}>Affiliated with the Indian National Congress</span>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
